
import React, { useEffect, useMemo, useState } from "react";
import {createClickableLink} from "../../../../components/common/datatable/DataTableUtils";
import {SearchSelectWithList} from "../../../../components/common/datatable/filter/SearchSelectWrapper";
import {formatValueAsDateAndTime} from "../../../../helpers/utils/DateUtils";
import {SearchDatePickerWrapper} from "../../../../components/common/datatable/filter/SearchDatePickerWrapper";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import {DataTable} from "../../../../components/common/datatable/DataTable";
import {DataTableColumn} from "../../../../components/common/datatable/DataTableTypes";
import {useGetRecordAuditNameListQuery, useSearchRecordAuditQuery} from "../recordAuditApi";
import {useGetAllUsersListQuery} from "../../../user/users/usersApi";
import {useFindUserSettingsByGroupNameQuery} from "../../../../components/common/userSetting/userSettingsApi";

const RecordAuditForm: React.FC = () => {

    const { data: userSetting } = useFindUserSettingsByGroupNameQuery("Record Audit");
    const [uniqueEntityNames, setUniqueEntityNames] = useState([]);
    const userListApi = useGetAllUsersListQuery("")
    const recordAuditEntityNameListApi=useGetRecordAuditNameListQuery("")
    const [crumbs] = useState([
        { content: "Home", url: "/home" },
        { content: "Record Audit", url: "" }
    ]);
    useEffect(() => {
        document.title = 'Record Audit';
        if (recordAuditEntityNameListApi?.data) {
            const uniqueEntityTypesSet = new Set(recordAuditEntityNameListApi?.data);

            const uniqueEntityTypesArray:any=[];

            Array.from(uniqueEntityTypesSet).map(entityType => (
                uniqueEntityTypesArray.push({
                    tableName: entityType,
                })
            ));
            setUniqueEntityNames(uniqueEntityTypesArray);
        }
    }, [recordAuditEntityNameListApi?.data]);

    const columns: DataTableColumn[] = [
            {
                label: "Action",
                accessor: "id",
                cell: (props: any) => {
                        let path = "/record-audit/" + props.row.original.id;
                        return createClickableLink(path, "", userSetting, true, "fa fa-edit cursor-pointer text-highlight-0",["AUDIT-R"]);

                }
            },
            {
                label: "Table Names", accessor: "entityTypeName",
                visibility :{hasShowSetting:false},
                filterOptions: [{
                    filterComponent: SearchSelectWithList(uniqueEntityNames, "tableName", "tableName", "Select Table Name...", false, "entityTypeName"),
                    overrideFilterAccessor: "entityTypeName",
                }]
            },
            {
                label: "Editor",
                accessor: "createdBy",
                visibility :{hasShowSetting:false},
                filterOptions: [{
                    filterComponent: SearchSelectWithList(userListApi.data, "username", "username", "Select Editor...", false, "createdBy"),
                    overrideFilterAccessor: "createdBy",
                }]
            },
            {
                label: "Creation Date", accessor: "creationDate",
                cell: (props: any) => {
                    return formatValueAsDateAndTime(props.row.original.creationDate);
                },
                filterOptions: [
                    {
                        filterComponent: <SearchDatePickerWrapper accessor={"createdDateFrom"} />,
                        overrideFilterAccessor: "createdDateFrom",
                        overrideFilterLabel: "Created Date - From",
                    },
                    {
                        filterComponent: <SearchDatePickerWrapper accessor={"createdDateTo"} />,
                        overrideFilterAccessor: "createdDateTo",
                        overrideFilterLabel: "Created Date - To",
                    }],
            },
            {
                label: "Initial Values",
                accessor: "initialValue",
                visibility :{hasShowSetting:false},
                cell: (props: any) => {
                    let content = props?.row?.original?.initialValue;
                    if (content?.length > 50) {
                        content = content.slice(0, 50) + "...";
                    }
                    return <><span className="text_wrap_msa_grid"
                                   title={props.row.original.initialValue}>{content}</span></>;
                },
            },
        {
            label: "New Values",
            accessor: "changedValue",
            visibility: {hasShowSetting: false},
            cell: (props: any) => {
                let content = props?.row?.original?.changedValue;
                if (content?.length > 50) {
                    content = content.slice(0, 50) + "...";
                }
                return <><span className="text_wrap_msa_grid"
                               title={props.row.original.changedValue}>{content}</span></>;
            },
        }
    ]
    return (
        <div className="user-container px-4 py-2">
        <div className="flex justify-between mb-2.5">
            <Breadcrumb crumbs={crumbs}/>
        </div>

                        <DataTable
                            columns={columns}
                            actions={{
                                fetchAction: useSearchRecordAuditQuery,
                                exportAction: null
                            }}
                            userSettingGroup={"Record Audit"}
                            defaultSortOptions={{
                                accessor: "creationDate",
                                direction: "asc"
                            }}
                            basePermission={"AUDIT"}
                        />

                    </div>
    );
};

export default RecordAuditForm;
